import { colorsPalettes } from "@similarweb/styles";
import { Box, Stack, Text } from "@similarweb/ui-components/foundations";

import { AIAgentEmailGraphContainer } from "app/pages/sales-intelligence/modules/ai-agent/containers/AIAgentEmailGraph/AIAgentEmailGraphContainer";
import ChartStreamService from "app/pages/sales-intelligence/modules/ai-agent/services/chart/chartService";

type Props = {
    email: string;
    chartAnchorIndex: number;
    chartJson: Record<string, unknown> | null;
    domain: string;
    graphRef: React.RefObject<HTMLDivElement>;
};

export const EmailWidgetBody = ({ email, chartAnchorIndex, chartJson, domain, graphRef }: Props) => {
    const bodyBeforeChart = email.slice(0, chartAnchorIndex);
    const bodyAfterChart = email.slice(chartAnchorIndex).replace(/^\n/, "");

    const isChartValid = !!chartJson && ChartStreamService.isChartObject(chartJson);

    return (
        <Stack
            gap="16px"
            data-automation="super-agent-email-widget-body"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
                whiteSpace="pre-wrap"
            >
                {bodyBeforeChart}
            </Text>
            {isChartValid ? (
                <Box ref={graphRef}>
                    <AIAgentEmailGraphContainer
                        key={ChartStreamService.getChartKey(chartJson ?? null)}
                        chart={chartJson ?? null}
                        selectedCompany={{ domain, companyName: domain }}
                    />
                </Box>
            ) : null}
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
                whiteSpace="pre-wrap"
            >
                {bodyAfterChart}
            </Text>
        </Stack>
    );
};
